import { DashboardShell } from "./DashboardShell";
import { MetricCard } from "./MetricCard";
import { ChartCard } from "./ChartCard";
import { ActivityPanel } from "./ActivityPanel";
import { erpPreview } from "@/data/dashboardPreview.data";
import { DashboardContent } from "./DashboardContent";

interface Props {
    accent: string;
}

export function ERPDashboard({
    accent,
}: Props) {
    const preview = erpPreview;
    
    return (
        <DashboardShell
            accent={accent}
            title="Enterprise ERP"
            subtitle="Real-time business operations dashboard"
            sidebar={[
                "Dashboard",
                "Inventory",
                "Procurement",
                "Warehouse",
                "Finance",
                "Sales",
                "Assets",
                "Reports",
            ]}
        >

            <DashboardContent

                accent={accent}

                preview={erpPreview}

                activityTitle="Operations Activity"

            />

            <div className="mt-6 grid gap-3 md:grid-cols-4">

                {
                    [
                        {
                            label:"Product Efficiency",
                            value:"94%",
                            trend:"+4%"
                        },
                        {
                            label:"Delivery Performance",
                            value:"97%",
                            trend:"+2%"
                        },
                        {
                            label:"Machine Uptime",
                            value:"99%",
                            trend:"+1%"
                        },
                        {
                            label:"Quality Score",
                            value:"98%",
                            trend:"+3%"
                        },
                    ].map((metric) => (

                        <MetricCard
                            key={metric.label}
                            accent={accent}
                            label={metric.label}
                            value={metric.value}
                            trend={metric.trend}
                        />

                    ))
                }

            </div>
            
            {/* <div className="grid gap-6"> */}

                {/* <div className="grid gap-5 md:grid-cols-4">
                    {
                        preview.metrics.map((metric) => (

                            <MetricCard
                                key={metric.label}
                                accent={accent}
                                label={metric.label}
                                value={metric.value}
                                trend={metric.trend}
                            />

                        ))
                    }

                </div>

                <div className="grid gap-6 lg:grid-cols-[2fr_1fr]">

                    <ChartCard
                        accent={accent}
                        title={preview.chart.title}
                        values={preview.chart.values}
                    />
                    <ActivityPanel
                        accent={accent}
                        title="Recent Activity"
                        items={preview.activities ?? []}
                    />

                </div> */}

                {/* <div className="grid gap-6 lg:grid-cols-3">
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Low Stock Alerts
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                {
                                    item: "Industrial Bearings",
                                    qty: "18",
                                    level: "Critical",
                                },
                                {
                                    item: "Hydraulic Oil",
                                    qty: "42",
                                    level: "Low",
                                },
                                {
                                    item: "Steel Sheets",
                                    qty: "61",
                                    level: "Low",
                                },
                                {
                                    item: "Control Modules",
                                    qty: "8",
                                    level: "Critical",
                                },
                            ].map((row) => (
                                <div
                                    key={row.item}
                                    className="flex items-center justify-between rounded-xl border border-border px-4 py-3"
                                >
                                    <div>

                                        <p className="font-medium">
                                            {row.item}
                                        </p>

                                        <p className="text-xs text-muted-foreground">
                                            Available Qty : {row.qty}
                                        </p>

                                    </div>

                                    <span
                                        className={`rounded-full px-3 py-1 text-xs font-semibold ${row.level === "Critical"
                                                ? "bg-red-100 text-red-700"
                                                : "bg-amber-100 text-amber-700"
                                            }`}
                                    >
                                        {row.level}
                                    </span>

                                </div>
                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Pending Purchase Orders
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                "PO-2034",
                                "PO-2035",
                                "PO-2038",
                                "PO-2042",
                                "PO-2045",
                            ].map((po) => (
                                <div
                                    key={po}
                                    className="flex items-center justify-between rounded-xl border border-border px-4 py-3"
                                >
                                    <div>

                                        <p className="font-medium">
                                            {po}
                                        </p>

                                        <p className="text-xs text-muted-foreground">
                                            Awaiting Finance Approval
                                        </p>

                                    </div>

                                    <button
                                        className="rounded-lg px-3 py-1 text-xs font-semibold text-white"
                                        style={{
                                            background: accent,
                                        }}
                                    >
                                        Review
                                    </button>

                                </div>
                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Warehouse Status
                        </h3>

                        <div className="mt-5 space-y-5">

                            {[
                                {
                                    warehouse: "Warehouse A",
                                    usage: 82,
                                },
                                {
                                    warehouse: "Warehouse B",
                                    usage: 61,
                                },
                                {
                                    warehouse: "Warehouse C",
                                    usage: 44,
                                },
                            ].map((row) => (
                                <div
                                    key={row.warehouse}
                                >
                                    <div className="flex justify-between text-sm">

                                        <span>
                                            {row.warehouse}
                                        </span>

                                        <span>
                                            {row.usage}%
                                        </span>

                                    </div>

                                    <div className="mt-2 h-2 rounded-full bg-muted">

                                        <div
                                            className="h-full rounded-full"
                                            style={{
                                                width: `${row.usage}%`,
                                                background: accent,
                                            }}
                                        />

                                    </div>

                                </div>
                            ))}

                        </div>

                    </div>

                </div> */}

            {/* </div> */}

        </DashboardShell>
    );
}